import { render, staticRenderFns } from "./WallpapersFilter.vue?vue&type=template&id=3edb38e8&"
import script from "./WallpapersFilter.vue?vue&type=script&lang=js&"
export * from "./WallpapersFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports